import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

//HOOKS
import useDecklistHandler from "../../hooks/useDecklistHandler";

const SERVER_URL = window.location.protocol + "//" + window.location.host;

function getBool(val) {
   if (val) {
      return !!JSON.parse(String(val).toLowerCase());
   }
}

export default function DecklistGrid({
   loadDownloader,
   clearDownloader
}) {
   // USE HOOK
   const [
      liveData,
      decklist,
      decklistCards,
      sideboardCards,
      allDecklists,
      {
         getAllDecklists
      },
   ] = useDecklistHandler();

   useEffect(() => {
      getAllDecklists();
   }, []);


   let columns;
   let initialState;

   columns = [
      {
         field: "id",
         headerName: "Decklist Id",
         editable: false,
         width: 100,
         filterable: false,
      },
      {
         field: "Format",
         headerName: "Format",
         editable: false,
         width: 120,
      },
      {
         field: "LastName",
         headerName: "Last Name",
         editable: false,
         width: 180,
      },
      {
         field: "FirstName",
         headerName: "First Name",
         editable: false,
         width: 150,
      },
      {
         field: "Archetype",
         headerName: "Archetype",
         editable: false,
         width: 350,
         renderCell: (params) => (
            <>
               <Stack direction='row' spacing={0.5}>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("W")) ? 1 : 0.1,

                     }}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/white.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("U")) ? 1 : 0.1,

                     }}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/blue.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("B")) ? 1 : 0.1,

                     }}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/black.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("R")) ? 1 : 0.1,

                     }}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/red.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("G")) ? 1 : 0.1,

                     }}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/green.png"}
                        width='100%'
                     />
                  </Box>
                  <Box
                     sx={{
                        width: 20,
                        height: 20,
                        opacity: getBool(params.row.Colors.includes("C")) ? 1 : 0.1,

                     }}
                  >
                     <img
                        src={SERVER_URL + "/images/mana/colorless.png"}
                        width='100%'
                     />
                  </Box>
                  {!params.value && <Box sx={{ pl: 2 }}>None</Box>}
                  {params.value && <Box sx={{ pl: 2 }}>{params.value}</Box>}
               </Stack>
            </>
         ),
      },
      {
         field: "PreviewDecklist",
         headerName: "",
         editable: false,
         width: 300,
         filterable: false,
         sortable: false,
         renderCell: (params) => (
            <>
               <Button
                  size='small'
                  onClick={() => loadDownloader("decklist", params.row.id, params.row.Format.includes("Draft") ? "draft" : "", "Decklist_" + params.row.LastName.replace(/[^a-zA-Z]/g, "") + params.row.FirstName.replace(/[^a-zA-Z]/g, "") + "_" + params.row.Archetype.replace(/[^a-zA-Z0-9]/g, ""))}
                  sx={{ mr: 1 }}
               >
                  {params.row.Format.includes("Draft") ? "LOAD DRAFT" : "LOAD CONSTRUCTED"}
               </Button>
            </>
         ),
      }
   ];

   initialState = {
      sorting: {
         sortModel: [{ field: "LastName", sort: "asc" }],
      },
      columns: {
         columnVisibilityModel: {
            id: false
         },
      },
   };

   const refreshGrid = () => {
      getAllDecklists();
      clearDownloader();
   };

   return (
      <>
         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
            <Typography variant="h3" component="div" sx={{ textTransform: "uppercase" }}>Decklists</Typography>
            <Button onClick={refreshGrid} color="error" variant="outlined">Refresh Data</Button>
         </Stack>
         <Box height={400} width="100%">
            {allDecklists && (
               <DataGrid
                  initialState={initialState}
                  sx={{ backgroundColor: "#efefef" }}
                  rows={allDecklists}
                  rowHeight={40}
                  columns={columns}
                  rowsPerPageOptions={[100, 200, 300, 1000, 5000]}
                  components={{ Toolbar: GridToolbar }}
                  componentsProps={{
                     toolbar: {
                        printOptions: {
                           disableToolbarButton: true,
                        },
                     },
                  }}
                  disableColumnSelector
                  disableDensitySelector
                  disableSelectionOnClick
               />
            )}
         </Box>
      </>
   );
}
